var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.14,
    height: 23.14,
    viewBox: "0 0 26.765 23.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor-data",
    transform: "translate(0.5 -33.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57670",
    "data-name": "Group 57670",
    transform: "translate(-0.5 33.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379268",
    "data-name": "Path 379268",
    d: "M26.265,35.277v14.01a2.428,2.428,0,0,1-1.725,1.7q-3.894.039-7.789.026v1.359a2.826,2.826,0,0,1,2.483,2.509,8.177,8.177,0,0,1,0,1.307.611.611,0,0,1-.5.5q-5.855.052-11.71,0a.611.611,0,0,1-.5-.5A3.373,3.373,0,0,1,7.6,52.92a3.107,3.107,0,0,1,1.411-.549V51.012q-3.895.013-7.789-.026A2.428,2.428,0,0,1-.5,49.287V35.277a2.233,2.233,0,0,1,1.986-1.751q11.4-.052,22.792,0A2.233,2.233,0,0,1,26.265,35.277Zm-24.726.1q11.344-.013,22.688.026a.6.6,0,0,1,.183.235q.052,6.639,0,13.278a.758.758,0,0,1-.235.235q-11.292.052-22.583,0a.758.758,0,0,1-.235-.235q-.052-6.639,0-13.278A1.425,1.425,0,0,1,1.539,35.382ZM9.171,53.731q3.712-.013,7.423.026A1.436,1.436,0,0,1,17.849,55.3H7.916A1.487,1.487,0,0,1,9.171,53.731Z",
    transform: "translate(0.5 -33.5)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.975
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57671",
    "data-name": "Group 57671",
    transform: "translate(5.823 37.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379269",
    "data-name": "Path 379269",
    d: "M120.719,116.441q1.464-.013,2.927.026a.365.365,0,0,1,.183.131,22.415,22.415,0,0,1,.052,3.032,1.071,1.071,0,0,0-.131.183,22.417,22.417,0,0,1-3.032.052.365.365,0,0,1-.183-.131,22.416,22.416,0,0,1-.052-3.032A.576.576,0,0,1,120.719,116.441Z",
    transform: "translate(-120.455 -116.437)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.979
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57672",
    "data-name": "Group 57672",
    transform: "translate(11.208 37.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379270",
    "data-name": "Path 379270",
    d: "M223.729,116.441q1.49-.013,2.98.026l.183.183a20.394,20.394,0,0,1,.052,2.875.582.582,0,0,1-.235.34q-1.49.052-2.98,0l-.183-.183a20.39,20.39,0,0,1-.052-2.875A.855.855,0,0,1,223.729,116.441Z",
    transform: "translate(-223.465 -116.437)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.969
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57673",
    "data-name": "Group 57673",
    transform: "translate(5.825 43.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379271",
    "data-name": "Path 379271",
    d: "M120.866,219.441q1.359-.013,2.718.026a.4.4,0,0,1,.288.183,21.66,21.66,0,0,1,.052,2.98.6.6,0,0,1-.183.235,20.392,20.392,0,0,1-2.875.052.427.427,0,0,1-.34-.235q-.052-1.49,0-2.98A.8.8,0,0,1,120.866,219.441Z",
    transform: "translate(-120.5 -219.437)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.969
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57674",
    "data-name": "Group 57674",
    transform: "translate(11.208 43.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379272",
    "data-name": "Path 379272",
    d: "M223.885,219.441q1.333-.013,2.666.026a.4.4,0,0,1,.392.392q.052,1.333,0,2.666a.4.4,0,0,1-.392.392q-1.359.052-2.718,0a.827.827,0,0,1-.288-.183,21.12,21.12,0,0,1-.052-2.927A.5.5,0,0,1,223.885,219.441Z",
    transform: "translate(-223.465 -219.437)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.958
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57675",
    "data-name": "Group 57675",
    transform: "translate(16.646 43.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379273",
    "data-name": "Path 379273",
    d: "M327.866,219.441q1.359-.013,2.718.026a.582.582,0,0,1,.34.235q.052,1.49,0,2.98l-.183.183a20.392,20.392,0,0,1-2.875.052.582.582,0,0,1-.34-.235q-.052-1.49,0-2.98A.8.8,0,0,1,327.866,219.441Z",
    transform: "translate(-327.5 -219.437)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.969
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorData);
export default __webpack_public_path__ + "static/media/monitor-data.38dfccacbae3f7ca5744ab5f93b15848.svg";
export { ForwardRef as ReactComponent };